import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22global-fonts.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22/_fonts/NeueHeitz-Regular.woff2%22,%22variable%22:%22--font-neueheitz%22,%22preload%22:true}],%22variableName%22:%22neueHeitz%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'neueHeitz', 'neueHeitz Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
